import React from 'react';
import { useList } from "@pankod/refine-core";
import { Tabs } from 'antd';
import { useMe } from "context/MeContext";
import HraResponsesChart from "../Charts/hra-responses-chart"
import { css } from '@emotion/react';
import "../adminDashboard.scoped.scss"
const { TabPane } = Tabs;

export const HraSummary: React.FC = () => {
  const { company, isSuperAdmin } = useMe();
  const {data: dataHraSummary} = useList({
    resource: "hra-summary",
    config: {
      filters: [
        {
          field: "employer_code",
          operator: "eq",
          value: company?.code
        }
      ]
    }
  })
  const HraSummary = dataHraSummary?.data
  console.log("hra summary:::", HraSummary)
  return (
    <div className='tab tab1' css={css`
        .recharts-wrapper {
          margin: auto !important;
          align-items: center;
        }
          .quote {
          position: relative;
          font-size: 16px;
          line-height: 1.6;
          color: #333 !important;
          padding: 1rem 1.5rem;
          margin: 1.5rem 1rem;
          background-color: #f9f9f9;
          border-left: 4px solid #333;
          border-right: 4px solid #333;
          text-align: left;
        }

        // .quote::before {
        //   content: "“";
        //   font-size: 2rem;
        //   position: absolute;
        //   top: 0.2rem;
        //   left: 0.5rem;
        //   color: #999;
        // }

        // .quote::after {
        //   content: "”";
        //   font-size: 2rem;
        //   position: absolute;
        //   bottom: 0.2rem;
        //   right: 0.5rem;
        //   color: #999;
        // }
      `}>
      {/* <h1>COMPANY WELLNESS</h1> */}
      <div className="" style={{ width: '100%'}}>
        <div className="">
          <div className="single-box challenge-title-group" >  
            <div className="left-challenge" style={{paddingRight:"30px"}}>
              <div className='challenge-title no-padding'>HRA Insights</div>
              <p style={{ paddingTop: 10 }}>Below is a summary based on users’ HRA responses</p> 
              {/* <div className="single-box-inside">
                <p className="box-content text-center">TBD: Summaries based on dimensions of wellness. Will be putting this together in next phase.</p> 
              </div> */}
              <div className="single-box-inside text-center">
                <div className="box-content">
                  <h3>Reported Causes of Employee Stress and Burnout</h3>
                  <p>The following is a summary of user-reported answers to the following questions:
                    <br/><i>In your own words, please explain what your biggest stressors are.</i>
                    <br/><i>In your own words, what causes you to feel burned out and what do you feel could be done about it?</i>
                  </p> 
                  <p className="quote">
                    {HraSummary?.[0]?.summary}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HraSummary;
